module.exports = __webpack_public_path__ + "media/images/landing/eno/product-17-d63945370896dff05ebfe3740b16eecc.png";